import React from 'react'

import { ToastConfig } from '../../../../libraries/toaster'
import CloseIcon from '../../../../assets/icons/close.svg?react'
import CheckedIcon from '../../../../assets/icons/checked.svg?react'

interface ToasterProps extends ToastConfig {
  onClose: () => void
}

const Toaster: React.FC<ToasterProps> = ({
  message,
  type = 'success',
  onClose
}) => {
  const isSuccess = type === 'success'
  const isError = type === 'error'
  return (
    <div
      className={`
        sticky z-50
        bottom-5 right-4
        sm:ml-auto w-[90dvw] sm:w-full sm:max-w-[400px]
        mx-auto sm:mx-0
        flex items-center justify-between gap-2 py-4 px-8 rounded-sm
        shadow-lg transition-all duration-300 ease-in-out
        border border-solid border-gray-200 border-1
        ${isSuccess && 'bg-white text-black'}
        ${isError && 'bg-red-500 text-white'}
      `}
    >
      <div className='flex items-center gap-x-4'>
        {type === 'success' && <CheckedIcon className='stroke-deep-green w-6 h-6' />}
        <span className='text-xs sm:text-xs'>{message}</span>
      </div>
      <button onClick={onClose}>
        <CloseIcon className={`w-6 h-6 ${isError && 'stroke-white'} ${isSuccess && 'stroke-gray'}`} />
      </button>
    </div>
  )
}

export default Toaster
